import { Radio } from '../models/radio';

export const Radios: Radio[] = [
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Voz di Bonaire',
        country: 'Bonaire',
        urlLogo: '//cdn.onlineradiobox.com/img/logo/2/48692.png',
        image: null,
        streamUrl: 'http://159.203.190.86:8304/;stream.mp3',
        id: '2',
        order : 2,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'

        
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    },
    {
        name: 'Radio Direct 107.1 FM',
        country: 'Curacao',
        urlLogo: 'http://cdn.onlineradiobox.com/img/logo/4/48694.png',
        image: null,
        streamUrl: 'http://s9.voscast.com:7364/;stream/1',
        id: '1',
        order : 1,
        // tslint:disable-next-line:max-line-length
        description: 'Radio Direct FM broadcasts both Willemstad, Netherlands Antilles and international music that varies too from genre to genre. Radio Direct 107.1 FM The most innovative local radio station, broadcasting live from Willemstad Curacao to the world. 24 hours of the Caribbean flavor.'
    }
];
